import type { CookieConsentChoices, GtagConsentKey } from './cookieConsentCatalog'

export type GtagConsentValue = 'granted' | 'denied'

export type GtagConsentState = Record<GtagConsentKey, GtagConsentValue>

type GtagFn = (...args: unknown[]) => void

type GtagWindow = Window & {
  dataLayer?: unknown[]
  gtag?: GtagFn
}

export function choicesToGtagConsent(
  choices: CookieConsentChoices,
): GtagConsentState {
  return {
    analytics_storage: choices.analytics_storage ? 'granted' : 'denied',
    ad_storage: choices.ad_storage ? 'granted' : 'denied',
  }
}

export function applyGtagConsentUpdate(choices: CookieConsentChoices): void {
  if (typeof window === 'undefined') return

  const consent = choicesToGtagConsent(choices)
  const w = window as GtagWindow

  w.dataLayer = w.dataLayer || []

  if (typeof w.gtag === 'function') {
    w.gtag('consent', 'update', consent)
    return
  }

  w.dataLayer.push(['consent', 'update', consent])
}
